import React, { useEffect, useState, useContext } from "react";
import LawPage from "./LawPage";
import Linking from "./Linking";
import Verktoy from "./Verktoy";
import LawChanges from "./LawChanges";
import Help from "./Help";
import * as wordAPI from "./JsFiles/WordAPI";
import { workItemObjectContext, accessesObjectContext } from "./App";

import "../style/KwordTabs.css";

export default function KwordTabs() {
  const [workItemObject, setWorkItemObject] = useContext(workItemObjectContext);
  const [accessesObject, setAccessesObject] = useContext(accessesObjectContext);
  const [selectedTextOnWordDoc, setSelectedTextOnWordDoc] = useState("");
  const [typeOfSearch, setTypeOfSearch] = useState("");

  useEffect(() => {
    addWordEventLinsteners();

    return () => {
      removeWordEventLinsteners();
    };
  }, []);

  function addWordEventLinsteners() {
    //word document text selection event listeners
    Office.context.document.addHandlerAsync(Office.EventType.DocumentSelectionChanged, (eventArgs) => {
      // Office.context.document.getSelectedDataAsync(Office.CoercionType.Ooxml, (asyncResult) => {
      const abortController = new AbortController();

      let activeTab = isLawPageOrManualLinkingOrAutomaticLinking();
      if (activeTab == "LawPage") {
        wordAPI.handleWordSelectionForNavigation(abortController).then((tag) => {
          if (tag) {
            const queryStr = '[data-kw-tag*="' + tag + '"]';
            let element = document.querySelector(queryStr);
            if (element) {
              if (abortController.signal.aborted) return;
              window.scrollTo(0, element.offsetTop - 200);
            }
          }
        });
      } else if (activeTab == "AutomaticLinking") {
        wordAPI.handleWordSelectionForAutomaticSearch(abortController).then((res) => {
          if (abortController.signal.aborted) return;
          setTypeOfSearchFunc(res.type);
          if (res.text && res.text != "") {
            setSelectedTextFunc(res.text);
          }
        });
      } else if (activeTab == "ManualLinking") {
        wordAPI.handleWordSelectionForManualSearch(abortController).then((text) => {
          if (abortController.signal.aborted) return;
          setTypeOfSearchFunc("selectedTextOnManualTab");
          if (text && text != "") {
            setSelectedTextFunc(text);
          }
        });
      }
    });
  }

  function setSelectedTextFunc(text) {
    setSelectedTextOnWordDoc(text);
  }

  function setTypeOfSearchFunc(type) {
    setTypeOfSearch(type);
  }

  function isLawPageOrManualLinkingOrAutomaticLinking() {
    if (isLawPageTabOn()) {
      return "LawPage";
    }
    if (isAutomaticLinkingTabOn()) {
      return "AutomaticLinking";
    }
    if (isManualLinkingTabOn()) {
      return "ManualLinking";
    }
    return false;
  }

  function removeWordEventLinsteners() {
    Office.context.document.removeHandlerAsync(Office.EventType.DocumentSelectionChanged);
  }

  function isLawPageTabOn() {
    let lawPageTab = document.querySelector("button#law-tab");
    if (lawPageTab) {
      return lawPageTab.classList.contains("active");
    }
    return false;
  }

  function isManualLinkingTabOn() {
    if (accessesObject.CanAddLinks) {
      let henvisningerTab = document.querySelector("button#henvisninger-tab");
      let manualTab = document.querySelector("button#Manual-tab");
      let isHenvisningerTabActive;
      let isManualTabActive;
      if (henvisningerTab) {
        isHenvisningerTabActive = henvisningerTab.classList.contains("active");
      }
      if (manualTab) {
        isManualTabActive = manualTab.classList.contains("active");
      }
      if (isHenvisningerTabActive && isManualTabActive) {
        return true;
      }
    }

    return false;
  }

  function isAutomaticLinkingTabOn() {
    if (accessesObject.CanAddLinks) {
      let henvisningerTab = document.querySelector("button#henvisninger-tab");
      let automaticTab = document.querySelector("button#Automatic-tab");
      let isHenvisningerTabActive;
      let isAutomaticTabActive;
      if (henvisningerTab) {
        isHenvisningerTabActive = henvisningerTab.classList.contains("active");
      }
      if (automaticTab) {
        isAutomaticTabActive = automaticTab.classList.contains("active");
      }
      if (isHenvisningerTabActive && isAutomaticTabActive) {
        return true;
      }
    }

    return false;
  }

  return (
    <div id="wholePage">
      {/* ------------ Tab Part -------------- */}
      <div className="tabPart">
        <ul className="nav nav-tabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="law-tab"
              data-bs-toggle="tab"
              data-bs-target="#lawTab"
              type="button"
              role="tab"
              aria-controls="lawTab"
              aria-selected="true"
              title="Rettskilden fra Lovdata som kommentarene er knyttet til"
            >
              <span className="headerButton-icon ms-fontColor-themePrimary">
                <i className="ms-Icon ms-Icon--FileComment"></i>
              </span>
              <span className="headerButton-label">Rettskilden</span>
            </button>
          </li>

          {accessesObject.CanAddLinks && (
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="henvisninger-tab"
                data-bs-toggle="tab"
                data-bs-target="#henvisninger"
                type="button"
                role="tab"
                aria-controls="henvisninger"
                aria-selected="false"
                title="Verktøy for å hjelpe til med å henvise riktig"
              >
                <span className="headerButton-icon ms-fontColor-themePrimary">
                  <i className="ms-Icon ms-Icon--Link"></i>
                </span>
                <span className="headerButton-label">Henvisninger</span>
              </button>
            </li>
          )}
          {accessesObject.HasLawChanges && (
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="endringer-tab"
                data-bs-toggle="tab"
                data-bs-target="#endringer"
                type="button"
                role="tab"
                aria-controls="endringer"
                aria-selected="false"
                title="Endringer"
              >
                <span className="headerButton-icon ms-fontColor-themePrimary">
                  <i className="ms-Icon ms-Icon--ChangeEntitlements"></i>
                </span>
                <span className="headerButton-label">Endringer</span>
              </button>
            </li>
          )}
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="verktoy-tab"
              data-bs-toggle="tab"
              data-bs-target="#verktoy"
              type="button"
              role="tab"
              aria-controls="verktoy"
              aria-selected="false"
              title="Verktøy"
            >
              <span className="headerButton-icon ms-fontColor-themePrimary">
                <i className="ms-Icon ms-Icon--Toolbox"></i>
              </span>
              <span className="headerButton-label">Verktøy</span>
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="help-tab"
              data-bs-toggle="tab"
              data-bs-target="#help"
              type="button"
              role="tab"
              aria-controls="help"
              aria-selected="false"
              title="Hjelp til bruk av verktøyet"
            >
              <span className="headerButton-icon ms-fontColor-themePrimary">
                <i className="bi bi-question-lg"></i>
              </span>
              <span className="headerButton-label">Hjelp</span>
            </button>
          </li>
        </ul>
      </div>
      {/* ------------ Inside Part -------------- */}
      <div className="tab-content" id="tabContent">
        <div className="tab-pane fade show active" id="lawTab" role="tabpanel" aria-labelledby="law-tab">
          <LawPage />
        </div>

        {accessesObject.CanAddLinks && (
          <div className="tab-pane fade" id="henvisninger" role="tabpanel" aria-labelledby="henvisninger-tab">
            <selectedTextOnWordDocContext.Provider value={[selectedTextOnWordDoc, setSelectedTextOnWordDoc]}>
              <Linking typeOfSearch={typeOfSearch} />
            </selectedTextOnWordDocContext.Provider>
          </div>
        )}
        {accessesObject.HasLawChanges && (
          <div className="tab-pane fade" id="endringer" role="tabpanel" aria-labelledby="endringer-tab">
            <LawChanges />
          </div>
        )}
        <div className="tab-pane fade" id="verktoy" role="tabpanel" aria-labelledby="verktoy-tab">
          <Verktoy />
        </div>
        <div className="tab-pane fade" id="help" role="tabpanel" aria-labelledby="help-tab">
          <Help />
        </div>
      </div>
    </div>
  );
}

export const selectedTextOnWordDocContext = React.createContext();
